module.exports = __webpack_public_path__ + "img/old-glass.a6797839.png";